//@flow

import styled from "styled-components"
import theme from "../Theme"

const Error = styled.span`
  display: block;
  padding: 0.25rem 0;
  font-size: 1rem;
  line-height: 1.25;
  color: ${props => props.theme.danger};
`

Error.defaultProps = { theme }

const BlockError = Error.extend`
  padding: 0.5rem;
  font-family: "din-condensed";
  color: #fff;
  background: ${props => props.theme.danger};
  margin: 0 1.15rem;
  font-weight: 400;
  font-size: 1.5rem;
`
export { BlockError }
export default Error



// WEBPACK FOOTER //
// ./src/UI/Form/Error.js